// Page-size choices for a pager dropdown.
//
// Only steps smaller than the result count are worth offering, and the last
// choice is always "All (n)" so the whole set can be pulled in one go:
//   total 25   -> 10, All (25)
//   total 200  -> 10, 50, 100, All (200)
//   total 7    -> 7        (one option, showing the exact count)
//   total 10   -> 10
export const PAGE_SIZE_LADDER = [10, 50, 100, 250, 500, 1000, 2500, 5000];

export const pageSizeOptions = (total, current = 10) => {
  const values = PAGE_SIZE_LADDER.filter((n) => n < total);

  // "All" only earns a slot once at least one step sits below it — otherwise the
  // count is smaller than the first step and there is nothing to choose between.
  const hasAll = values.length > 0;

  if (!hasAll) {
    // Nothing to choose: show a single option carrying the exact record count.
    // The value stays on the active page size so the <select> keeps matching
    // state — with fewer records than a page, the two are equivalent anyway.
    const short = total > 0 && total < current;
    return [{ value: current, label: String(short ? total : current) }];
  }

  values.push(total);

  // Whatever is selected must stay selectable, or the <select> shows blank.
  if (!values.includes(current)) values.push(current);

  return [...new Set(values)]
    .sort((a, b) => a - b)
    .map((n) => ({
      value: n,
      label: n === total ? `All (${total})` : String(n),
    }));
};
